import { Card } from "@molecules";
import { Bar } from "@organisms";

export type DashboardLayoutTemplateProps = {
  children: JSX.Element;
  header: string;
  subheader: JSX.Element;
};

export const DashboardLayoutTemplate = ({
  children,
  header,
  subheader,
}: DashboardLayoutTemplateProps): JSX.Element => {
  return (
    <div className="flex flex-row w-screen h-screen min-h-screen overflow-x-hidden bg-neutral-lightmax pr-4">
      <div className="h-screen min-h-screen w-60 fixed bg-white">
        <Bar variant="side" />
      </div>
      <div className="flex w-screen h-screen min-h-screen bg-neutral-lightmax grid pt-10 pb-0 relative left-60 mr-60">
        <div className="pl-6 h-full bg-neutral-lightmax overflow-y-auto hide-scrollbar pb-20">
          <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
            <div>
              <h3 className="color-black text-3xl">{header}</h3>
              <div>{subheader}</div>
            </div>
          </div>
          <div className="border-b border-neutral-medium w-full mt-6"></div>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};
